module.exports = "#graficos h2 {\r\n    font-size: 14pt;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = ./src/app/home/home.component.css
// module chunks = main